export const ORIGEM_SUBPREFEITURA = 'Subprefeitura';
export const ORIGEM_CLIMP = 'CLIMP';

export const TITULO_LISTA_POR_ORIGEM = {
  [ORIGEM_SUBPREFEITURA]: 'BFSs Subprefeitura',
  [ORIGEM_CLIMP]: 'BFSs de CLIMP',
};

export function somar(lista, campo) {
  return (lista || []).reduce((soma, item) => soma + (item[campo] || 0), 0);
}

export function filtrarPorModalidade(tipoServico, modalidade) {
  return (tipoServico || []).filter((x) => x.modalidadeServico === modalidade);
}

// A API devolve as BFS da Subprefeitura antes das de CLIMP; a ordem é preservada aqui.
// Aceita também a lista só de ids da versão anterior da API, tratada como Subprefeitura.
export function agruparBfsPorOrigem(bfsLista) {
  const grupos = [];
  (bfsLista || []).forEach((item) => {
    const bfs = typeof item === 'number' ? { bfs_id: item, origem: ORIGEM_SUBPREFEITURA } : item;
    const origem = bfs.origem || ORIGEM_SUBPREFEITURA;
    let grupo = grupos.find((g) => g.origem === origem);
    if (!grupo) {
      grupo = { origem, titulo: TITULO_LISTA_POR_ORIGEM[origem] || origem, bfsIds: [] };
      grupos.push(grupo);
    }
    grupo.bfsIds.push(bfs.bfs_id);
  });
  return grupos;
}
